<template>
  <div>
    <moule1 :dominItem="dominItem" v-if="dominItem && dominItem.remark === '1'"></moule1>
    <moule2 :dominItem="dominItem" v-if="dominItem && dominItem.remark === '2'"></moule2>
    <moule3 :dominItem="dominItem" v-if="dominItem && dominItem.remark === '3'" class="aaaaa"></moule3>
    <moule4 :dominItem="dominItem" v-if="dominItem && dominItem.remark === '4'"></moule4>
    <moule5 :dominItem="dominItem" v-if="dominItem && dominItem.remark === '5'"></moule5>
    <moule6 :dominItem="dominItem" v-if="dominItem && dominItem.remark === '6'"></moule6>
    <moule7 :dominItem="dominItem" v-if="dominItem && dominItem.remark === '7'"></moule7>
    <moule8 :dominItem="dominItem" v-if="dominItem && dominItem.remark === '8'"></moule8>
    <moule9 :dominItem="dominItem" v-if="dominItem && dominItem.remark === '9'"></moule9>
    <moule10 :dominItem="dominItem" v-if="dominItem && dominItem.remark === '10'"></moule10>
    <moule11 :dominItem="dominItem" v-if="dominItem && dominItem.remark === '11'"></moule11>
    <moule12 :dominItem="dominItem" v-if="dominItem && dominItem.remark === '12'"></moule12>
    <moule13 :dominItem="dominItem" v-if="dominItem && dominItem.remark === '13'"></moule13>
    <moule14 :dominItem="dominItem" v-if="dominItem && dominItem.remark === '14'"></moule14>
    <moule15 :dominItem="dominItem" v-if="dominItem && dominItem.remark === '15'"></moule15>
    <moule16 :dominItem="dominItem" v-if="dominItem && dominItem.remark === '16'"></moule16>
    <moule17 :dominItem="dominItem" v-if="dominItem && dominItem.remark === '17'"></moule17>
    <moule18 :dominItem="dominItem" v-if="dominItem && dominItem.remark === '18'"></moule18>
    <moule19 :dominItem="dominItem" v-if="dominItem && dominItem.remark === '19'"></moule19>
    <moule20 :dominItem="dominItem" v-if="dominItem && dominItem.remark === '20'"></moule20>
    <detailsCn :dominItem="dominItem" v-if="dominItem && dominItem.remark === '21'"></detailsCn>
    <detailsEn :dominItem="dominItem" v-if="dominItem && dominItem.remark === '22'"></detailsEn>
    <detailsJp :dominItem="dominItem" v-if="dominItem && dominItem.remark === '23'"></detailsJp>
    <detailsKr :dominItem="dominItem" v-if="dominItem && dominItem.remark === '24'"></detailsKr>
  </div>
</template>
<script>
import detailsEn from '../components/details/den'
import detailsCn from '../components/details/dcn'
import detailsJp from '../components/details/djp'
import detailsKr from '../components/details/dkr'
import {getDomainName} from "@/api";
import moule1 from "@/components/index/mould1/detail";
import moule2 from "@/components/index/mould2/detail";
import moule3 from "@/components/index/mould3/detail";
import moule4 from "@/components/index/mould4/detail";
import moule5 from "@/components/index/mould5/detail";
import moule6 from "@/components/index/mould6/detail";
import moule7 from "@/components/index/mould7/detail";
import moule8 from "@/components/index/mould8/detail";
import moule9 from "@/components/index/mould9/detail";
import moule10 from "@/components/index/mould10/detail";
import moule11 from "@/components/index/mould11/detail";
import moule12 from "@/components/index/mould12/detail";
import moule13 from "@/components/index/mould13/detail";
import moule14 from "@/components/index/mould14/detail";
import moule15 from "@/components/index/mould15/detail";
import moule16 from "@/components/index/mould16/detail";
import moule17 from "@/components/index/mould17/detail";
import moule18 from "@/components/index/mould18/detail";
import moule19 from "@/components/index/mould19/detail";
import moule20 from "@/components/index/mould20/detail";

export default {
  components: {
    detailsCn,detailsEn,detailsJp, detailsKr,
    moule3, moule4, moule2, moule5, moule1,moule6,moule7,
  moule8,moule9,moule10, moule11,moule12, moule13,moule14,moule15,moule16,
    moule17,moule18,moule19, moule20
  },
  data() {
    return {
      dominItem: undefined
    };
  },

  created() {
    setTimeout(() => {
      this.dominItem = JSON.parse(localStorage.getItem('dominItem'))
    }, 500)
  },

  methods: {
  },
};
</script>
<style lang="scss" scoped>
.aaaaa{
  .article-title {
    border: 1px solid red;
  }
}
</style>
